import { apiSlice } from '../../store/apiSlice';

export const extendedApiSlice = apiSlice
  .enhanceEndpoints({ addTagTypes: ['PremiumFisheries'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getPremiumFisheries: builder.query({
        query: () => ({
          url: 'premium-fisheries',
          method: 'get',
        }),
        providesTags: ['PremiumFisheries'],
      }),
    }),
  });

export const { useGetPremiumFisheriesQuery } = extendedApiSlice;
